export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
  author: string;
  featured: boolean;
}

export const articles: Article[] = [
  {
    slug: 'anzai-rara-2025-year-review',
    title: '安斋拉拉2025年度回顾：辉煌与突破的一年',
    excerpt: '回顾安斋拉拉在2025年的精彩表现，从年度代表作品到行业荣誉，全面梳理这一年的辉煌历程与艺术突破。',
    content: `<p>2025年对于安斋拉拉来说是极具里程碑意义的一年。从年初的惊艳亮相到年末的完美收官，她以一贯的专业态度和不断精进的演技，为粉丝们带来了无数难忘的瞬间。</p>
    <h2>年度代表作品回顾</h2>
    <p>今年安斋拉拉共推出了超过15部新作品，其中多部作品在各大平台获得极高的评价。她的表演风格更加成熟，角色塑造也愈发立体丰满，展现出了令人惊叹的艺术成长。</p>
    <p>特别值得一提的是，她在今年尝试了多个全新类型的角色，突破了以往的形象框架，为观众带来了耳目一新的视觉体验。这种勇于挑战自我、不断突破边界的精神，正是她能够持续保持高人气的关键所在。</p>
    <h2>行业荣誉与认可</h2>
    <p>凭借出色的表现，安斋拉拉在今年获得了多项重要提名和奖项。这些荣誉不仅是对她个人努力的肯定，也标志着她在行业内的地位进一步巩固。</p>
    <p>从新人时期至今，安斋拉拉的成长轨迹堪称行业典范。她以实际行动证明了，只要保持初心、坚持专业，就一定能够在竞争激烈的环境中脱颖而出。</p>
    <h2>粉丝互动与影响力</h2>
    <p>2025年，安斋拉拉在社交媒体上的影响力持续扩大，粉丝数量突破50万。她积极与粉丝互动，定期分享工作与生活的点滴，拉近了与支持者之间的距离。</p>
    <p>展望2026年，我们有理由相信，安斋拉拉会带来更多惊喜，继续书写属于她的传奇篇章。</p>`,
    category: 'news',
    categoryName: '最新动态',
    date: '2026-01-15',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20minimalist%20editorial%20photography%20with%20soft%20warm%20coral%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20gentle%20natural%20lighting%2C%20clean%20aesthetic%20background%2C%20sophisticated%20atmospheric%20mood%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=article-review-2025&orientation=landscape',
    tags: ['年度回顾', '安斋拉拉', '作品总结', '2025'],
    author: '编辑团队',
    featured: true,
  },
  {
    slug: 'anzai-rara-classic-works-top10',
    title: '安斋拉拉经典作品TOP10推荐：入门必看指南',
    excerpt: '精心挑选安斋拉拉从业以来最值得观看的十部经典作品，为新粉丝提供入门指南，也为老粉丝重温经典。',
    content: `<p>对于刚刚开始了解安斋拉拉的粉丝来说，面对庞大的作品库可能会感到无从下手。本文精选了十部最具代表性和观赏价值的经典作品，帮助你快速领略她的魅力。</p>
    <h2>入选标准</h2>
    <p>本榜单综合考虑了作品的艺术水准、市场反响、粉丝评价以及安斋拉拉本人在其中的表现力等多个维度，力求客观全面地呈现她的最佳作品。</p>
    <h2>TOP 1-5 必看经典</h2>
    <p>排名前五的作品代表了安斋拉拉不同时期的巅峰状态。从早期展现天赋的惊艳之作，到中期沉淀后更加成熟的表演，每一部都值得反复品味。</p>
    <p>其中排名第一的作品更是被众多粉丝誉为"入坑神作"，无论是剧情设计还是安斋拉拉的表现都达到了极高的水准。如果你只能选一部作品来了解她，这部绝对是不二之选。</p>
    <h2>TOP 6-10 隐藏珍宝</h2>
    <p>后五部作品虽然在知名度上可能略逊于前五，但各有独特的魅力。它们展示了安斋拉拉在不同题材和风格中的适应能力，是其全面实力的最佳证明。</p>
    <p>每一位资深粉丝的心中都有自己的TOP10，欢迎在社区中分享你的排名！</p>`,
    category: 'works',
    categoryName: '作品集',
    date: '2026-02-20',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20minimalist%20editorial%20photography%20with%20soft%20warm%20coral%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20gentle%20natural%20lighting%2C%20clean%20aesthetic%20background%2C%20sophisticated%20atmospheric%20mood%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=article-top10&orientation=landscape',
    tags: ['经典作品', 'TOP10', '入门指南', '安斋拉拉'],
    author: '编辑团队',
    featured: true,
  },
  {
    slug: 'anzai-rara-biography',
    title: '安斋拉拉个人档案全解析：从出道到成名之路',
    excerpt: '完整梳理安斋拉拉的职业生涯轨迹，从出道契机到成名过程，深度了解这位艺人的成长故事与行业地位。',
    content: `<p>安斋拉拉，这个名字如今已经成为日本娱乐圈中不可忽视的存在。但鲜为人知的是，她的成功并非一蹴而就，而是经历了漫长的积累与沉淀。</p>
    <h2>出道之前</h2>
    <p>在正式出道之前，安斋拉拉就展现出了对表演艺术的浓厚兴趣。她曾在多个培训机构接受系统的表演训练，为日后的职业生涯打下了坚实的基础。</p>
    <h2>出道与早期生涯</h2>
    <p>安斋拉拉的出道可以说是一鸣惊人。凭借出众的外形条件和扎实的表演功底，她迅速在业界崭露头角。早期作品中展现出的天赋与潜力，让众多业内人士对她寄予厚望。</p>
    <h2>稳步上升期</h2>
    <p>经过初期的积累，安斋拉拉进入了职业生涯的快速上升期。这一阶段，她不断挑战更复杂的角色，演技日益精进，作品质量也稳步提升。粉丝基础在此期间迅速扩大。</p>
    <h2>巅峰时期与现状</h2>
    <p>如今的安斋拉拉已经站在了行业的顶端。她不仅是备受观众喜爱的艺人，更是后辈学习的榜样。她的成功故事激励着无数追梦人，证明了努力与坚持的力量。</p>`,
    category: 'profile',
    categoryName: '资料档案',
    date: '2026-03-10',
    readTime: '15分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20minimalist%20editorial%20photography%20with%20soft%20warm%20coral%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20gentle%20natural%20lighting%2C%20clean%20aesthetic%20background%2C%20sophisticated%20atmospheric%20mood%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=article-bio&orientation=landscape',
    tags: ['个人档案', '职业生涯', '安斋拉拉', '成长故事'],
    author: '编辑团队',
    featured: false,
  },
  {
    slug: 'anzai-rara-latest-work-review',
    title: '安斋拉拉最新力作深度评测：风格突破与新尝试',
    excerpt: '详细评测安斋拉拉最新发布的作品，从剧情、表演、制作等多个维度进行深入分析，解读她最新的艺术探索。',
    content: `<p>安斋拉拉的最新作品一经发布便引发了广泛讨论。这部作品在多个方面展现了她的新突破，无论是角色定位还是表演风格，都呈现出与以往不同的面貌。</p>
    <h2>剧情概述</h2>
    <p>这部新作在剧情设计上更加注重故事性和情感表达，整体节奏把控得当，为安斋拉拉的表演提供了充分的发挥空间。剧本的深度和复杂度较以往有明显提升。</p>
    <h2>表演亮点</h2>
    <p>安斋拉拉在本作中的表演堪称精湛。她在情感层次的把控上更加细腻，无论是微表情还是肢体语言都展现出极高的专业水准。观众可以明显感受到她在表演上的成长与突破。</p>
    <h2>制作水准</h2>
    <p>从制作角度来看，本作在摄影、灯光、场景布置等方面都达到了业界一流水平。精良的制作进一步衬托了安斋拉拉的表演魅力。</p>
    <h2>综合评价</h2>
    <p>总体而言，这部新作是安斋拉拉职业生涯中又一个重要的里程碑。它展示了一位成熟艺人的自信与实力，也让人对她未来的发展充满期待。强烈推荐所有粉丝观看。</p>`,
    category: 'news',
    categoryName: '最新动态',
    date: '2026-04-05',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20minimalist%20editorial%20photography%20with%20soft%20warm%20coral%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20gentle%20natural%20lighting%2C%20clean%20aesthetic%20background%2C%20sophisticated%20atmospheric%20mood%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=article-latest-review&orientation=landscape',
    tags: ['最新作品', '深度评测', '安斋拉拉', '新尝试'],
    author: '编辑团队',
    featured: true,
  },
  {
    slug: 'anzai-rara-fan-community-guide',
    title: '安斋拉拉粉丝社区全攻略：如何加入与参与',
    excerpt: '详细介绍安斋拉拉粉丝社区的各个板块和互动方式，帮助新粉丝快速融入这个温暖的大家庭。',
    content: `<p>安斋拉拉的粉丝社区是一个充满活力和温暖的地方。无论你是资深粉丝还是刚刚入坑的新人，这里都欢迎你的加入。</p>
    <h2>社区板块介绍</h2>
    <p>粉丝社区分为多个主题板块，包括作品讨论区、图集分享区、资讯交流区和线下活动区等。每个板块都有不同的功能和特色，满足粉丝们的多样化需求。</p>
    <h2>如何参与讨论</h2>
    <p>参与社区讨论非常简单，你可以发表自己的观点、分享收藏、提问求助或参与投票活动。社区氛围友好包容，新人不必担心自己的问题是否"太小白"。</p>
    <h2>社区活动</h2>
    <p>社区定期举办各类线上和线下活动，包括作品评选、知识问答、粉丝聚会等。这些活动是结识同好、加深交流的绝佳机会。</p>
    <h2>社区规范</h2>
    <p>为了维护良好的社区环境，请大家自觉遵守社区规范，尊重每位成员，友善交流，共同营造积极健康的讨论氛围。</p>`,
    category: 'community',
    categoryName: '粉丝社区',
    date: '2026-05-18',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20minimalist%20editorial%20photography%20with%20soft%20warm%20coral%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20gentle%20natural%20lighting%2C%20clean%20aesthetic%20background%2C%20sophisticated%20atmospheric%20mood%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=article-community&orientation=landscape',
    tags: ['粉丝社区', '社区攻略', '安斋拉拉', '互动指南'],
    author: '编辑团队',
    featured: false,
  },
  {
    slug: 'anzai-rara-interview-2026',
    title: '独家访谈：安斋拉拉谈职业感悟与未来规划',
    excerpt: '安斋拉拉接受独家深度访谈，分享多年从业感悟、对表演艺术的理解，以及对于未来的规划和期待。',
    content: `<p>在一个温暖的午后，我们有幸与安斋拉拉进行了一次深入的对话。褪去银幕上的光环，生活中的她展现出了令人惊喜的另一面。</p>
    <h2>关于职业选择</h2>
    <p>"选择这条路并不容易，但我从未后悔。"安斋拉拉坦言，每一个选择都是人生的一部分，重要的是对自己的决定负责。她的坦诚和勇敢令人动容。</p>
    <h2>关于表演艺术</h2>
    <p>在谈到表演时，安斋拉拉的眼神变得格外认真。"表演对我来说不仅仅是工作，更是一种表达自我的方式。每一个角色都是一次新的探索和挑战。"</p>
    <p>她认为，好的表演应该能够触动人心，引发观众的共鸣。这也是她一直以来追求的目标。</p>
    <h2>关于粉丝</h2>
    <p>"粉丝的支持是我最大的动力。"安斋拉拉动情地说，"每次看到他们的留言和鼓励，都让我觉得所有的付出都是值得的。我希望能够用更好的作品回报他们的爱。"</p>
    <h2>未来规划</h2>
    <p>对于未来，安斋拉拉表示希望能够尝试更多不同类型的角色，不断突破自我。"我还有很多想做的事情，很多想尝试的方向。未来的路还很长，我期待每一个新的挑战。"</p>`,
    category: 'interviews',
    categoryName: '深度访谈',
    date: '2026-06-22',
    readTime: '20分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20minimalist%20editorial%20photography%20with%20soft%20warm%20coral%20and%20cream%20tones%2C%20artistic%20abstract%20composition%2C%20gentle%20natural%20lighting%2C%20clean%20aesthetic%20background%2C%20sophisticated%20atmospheric%20mood%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=article-interview-2026&orientation=landscape',
    tags: ['独家访谈', '深度对谈', '安斋拉拉', '未来规划'],
    author: '编辑团队',
    featured: true,
  },
];

export const faqData = [
  {
    question: '安斋拉拉是谁？',
    answer: '安斋拉拉是日本备受关注的知名艺人，以其出色的外形条件和扎实的表演功底在业界享有盛誉。她出道以来推出了大量优秀作品，积累了庞大的粉丝群体，是行业内最具影响力的人物之一。',
  },
  {
    question: '如何查找安斋拉拉的作品？',
    answer: '您可以通过本站的"作品集"栏目按发布时间浏览安斋拉拉的全部作品。我们提供了详细的分类筛选功能，支持按照年份、系列、类型等维度进行检索，方便您快速找到想看的内容。',
  },
  {
    question: '安斋拉拉的最新动态如何获取？',
    answer: '关注本站"最新动态"栏目即可第一时间获取安斋拉拉的新作发布、活动日程、社交动态等最新消息。我们也建议订阅本站的资讯推送，确保不会错过任何重要信息。',
  },
  {
    question: '如何加入安斋拉拉的粉丝社区？',
    answer: '您可以访问本站的"粉丝社区"板块，注册账号后即可参与讨论、分享收藏、交流心得。社区氛围友好包容，无论您是资深粉丝还是新入坑的朋友，都能在这里找到归属感。',
  },
  {
    question: '本站内容是否定期更新？',
    answer: '是的，我们致力于为您提供最新、最全的安斋拉拉相关内容。编辑团队会持续追踪最新资讯和动态，确保网站信息的时效性和准确性。建议将本站加入收藏，随时回来查看更新。',
  },
  {
    question: '如何联系本站团队？',
    answer: '您可以通过"关于我们"页面中的联系表单与我们取得联系。无论是内容建议、合作意向还是其他问题，我们都非常乐意倾听您的声音，并会尽快给予回复。',
  },
];